export interface Floor {
   id: string
   type: "floor"
   name: string
   selected?: boolean
   blocks?: Block[]
}

export interface Block {
   id: string
   type: "block"
   name: string
   selected?: boolean
   floors?: Floor[]
}

export interface Facility {
   id: string
   type: "facility"
   name: string
   selected?: boolean
   blocks?: Block[]
}

export enum AlertConfigurationModule {
   NAME = "name",
   HEART_RATE = "heart-rate",
   RESPIRATORY_RATE = "respiratory-rate",
   OXYGEN_LEVEL = "oxygen-level",
   SOUND = "sound",
   DATA_SHARING = "data-sharing",
   COLOR = "color",
   DELAY = "delay",
   NO_VITALS_STATIC_READINGS = "no-vitals-static-readings",
   NO_VITALS_WEARABLE_READINGS = "no-vitals-wearable-readings",
   SENSOR_TYPE_ENABLED = "enabled",
   ALARM_ENABLED = "alarm-enabled",
   EMAIL_MESSAGE = "email-message",
   TEXT_MESSAGE = "text-message",
}
